/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_ChooseInputs */

const en_pc_dl_choose = /** @type {(inputs: Pc_Dl_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose your platform`)
};

const zh_pc_dl_choose = /** @type {(inputs: Pc_Dl_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择你的平台`)
};

/**
* | output |
* | --- |
* | "Choose your platform" |
*
* @param {Pc_Dl_ChooseInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_choose = /** @type {((inputs?: Pc_Dl_ChooseInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_ChooseInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_choose(inputs)
	return zh_pc_dl_choose(inputs)
});
export { pc_dl_choose as "pc.dl.choose" }